// Optional parameter includeMargin is used when calculating outer dimensions  
module.exports = (jQuery) => {
    (function ($) {
        $.fn.getHiddenDimensions = function (outer = true) {
            var $this = $(this);
            
            if ($this.length == 0) {
                return false;
            }

            var $clone = $this.clone()
                .show()
                .css('visibility','hidden')
                .insertAfter($this);  

            var result = {
                width:      (outer) ? $clone.outerWidth() : $clone.innerWidth(), 
                height:     (outer) ? $clone.outerHeight() : $clone.innerHeight(), 
                offsetTop:  $clone.offset().top, 
                offsetLeft: $clone.offset().left
            };
            $clone.remove();

            return result;
        }
    }(jQuery))
}


// WEBPACK FOOTER //
// ./src/jquery-extend.js